import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TaxrateService } from './taxrate.service';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppMainComponent } from 'src/app/app.main.component';
import { SetupService } from '../setup.service';
import { AddYearPipe } from 'src/app/shared/pipes/add-year.pipe';
import { ObjectNames, Status, Severity, Answer } from '../../constants/constants';
import { TitleCasePipe } from '@angular/common';
import { AccountService } from 'src/app/accounts/accountService';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { CategoryService } from '../../product/category/category.service';
import { Subject, takeUntil } from 'rxjs';
import { AppMainService } from 'src/app/app-main.service';
import { ITaxProductCategory } from './models/tax-product-category.model';
import { ITaxCountry } from './models/tax-country.model';

@Component({
  selector: 'app-taxrate',
  templateUrl: './taxrate.component.html',
  styleUrls: ['./taxrate.component.scss']
})
export class TaxrateComponent implements OnInit, OnDestroy {
  @Input() rateTypes: any[] = [];
  @Input() financialAccounts: any[] = [];

  taxForm: FormGroup;
  allRates: any[] = [];
  vendors: any[] = [];
  addEditRateHeader: string;
  displayRateAdd: boolean = false;
  isAddTaxRate: boolean = false;
  statusDisabled: boolean = false;
  statusConstants = Status;
  answertypeConstants = Answer;
  discountConstantsProperty = ObjectNames.setupConstants;
  invalidData: boolean = false;
  enable = false;

  countries: any[] = [];
  states: any[] = [];
  CategoryLists: any[] = [];
  productInventoryGroup: any;
  addressTypes = [];
  subTaxCodes = [];
  taxDetails;
  disableRateType = true;
  unsubscribe$: Subject<void> = new Subject<void>();

  menus: MenuItem[];
  activeIndex = 0;
  selectedCountryId = 0;

  // tax country
  displayTaxCountryAdd = false;
  taxCountryAddDialogHeader: string;
  taxCountryForm: FormGroup;
  selectedTaxCountry;
  disableCountrySelection = true;
  disableAddressTypeSelection = true;
  expandedRowsClass: {} = {};

  // displayAddTaxCode = false; 
  // taxCodeForm: FormGroup;

  constructor(private taxService: TaxrateService, private confirmationService: ConfirmationService, private messageService: MessageService,
    private fb: FormBuilder, private app: AppMainComponent, private setupService: SetupService, private yearPipe: AddYearPipe,
    private titlecasePipe: TitleCasePipe, private accountService: AccountService, private service: ConfigurationService,
    private catService: CategoryService, private appMainService: AppMainService) { }

  ngOnInit(): void {
    this.menus = [{}, {}];
    this.initTaxForm();
    this.initTaxCountryForm();
    // this.initTaxCodeForm();
    this.setupService.getTax().subscribe(tax => {
      if (tax) {
        // this.showAddRate();
        this.showTaxCountryAddDialog();
      }
    });
    this.loadTaxList();
    //this.loadVendorList();
    //this.getTaxGroup();
    this.getAllAddressTypes();
    this.getAllCountries();
    this.getAllProductCategories();
  }

  initTaxForm() {
    this.taxForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      organizationId: [this.app.companyId],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      description: [''],
      // subTax: this.fb.array([]),
      addressTypeId: ['', Validators.required],
      financialAccountId: ['', Validators.required],
      vendorId: [''],
      isDefault: [false],
      isValid: [true],
      validFromDate: [new Date().toISOString()],
      validToDate: [this.yearPipe.transform(new Date())],
      countryId: ['', Validators.required],
      stateId: [''],
      zipCode: [''],
      taxProductCategory: [''],
      statusId: [true],
      taxRate: [0],
    });
  }

  initTaxCountryForm() {
    this.taxCountryForm = this.fb.group({
      id: [0],
      countryId: ['', Validators.required],
      addressTypeId: ['', Validators.required],
    });
  }

  // initTaxCodeForm() {
  //   this.taxCodeForm = this.fb.group({
  //       id: [0],
  //       name: [
  //           "",
  //           [Validators.required],
  //       ],
  //   });
  // }

  // get subTax(){
  //   return this.taxForm?.controls["subTax"] as FormArray;
  // }

  // getFormGroupAt(index: number){
  //   return this.subTax.at(index) as FormGroup;
  // }

  // deleteSubTax(index: number){
  //   this.subTax.removeAt(index);
  // }

  // addSubTax(){
  //   const subTaxForm = this.fb.group({
  //     id: [0],
  //     code: ['', Validators.required],
  //     typeId: [this.rateTypes && this.rateTypes.length ? this.rateTypes[0] : '', Validators.required],
  //     taxRate: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
  //   });
  //   this.subTax.push(subTaxForm);
  // }


  loadTaxList(status?) {
    this.taxService.getSetTaxConfig(status).subscribe((tax) => {
      if (tax) {
        this.enable = tax.item1;
        this.allRates = tax.item2;
      }
    })
  }

  loadVendorList() {
    this.taxService.getVendorList().subscribe((vendor) => {
      this.vendors = vendor;
    })
  }

  taxRateDefault(rate) {
    this.allRates.forEach(element => {
      if (element.id != rate.id) {
        element.isDefault = false;
      }
    });
    this.updateTax(rate);
  }

  showTaxCountryAddDialog() {
    this.taxCountryAddDialogHeader = ObjectNames.setupConstants.TaxCountryAddDialogHeader;
    this.displayTaxCountryAdd = true;
    this.initTaxCountryForm;
    this.setEditableAndDefaultAddressType(false);
  }

  setEditableAndDefaultAddressType(isEditable) {
    // default value
    if (this.addressTypes) {
      let shippingType = this.addressTypes?.find(t => t?.name?.toLowerCase() == "shipping");
      if (shippingType && shippingType.id) {
        this.taxCountryForm.controls.addressTypeId.setValue(shippingType.id);
      }
    }

    // enable/disable address type field
    if (!isEditable) {
      this.taxCountryForm.controls.addressTypeId.disable();
    }
  }

  showAddRate(taxCountry) {
    this.selectedTaxCountry = taxCountry;
    this.addEditRateHeader = ObjectNames.setupConstants.AddRateTitle;
    this.displayRateAdd = true;
    this.statusDisabled = false;
    this.invalidData = false;
    this.isAddTaxRate = true;
    this.initTaxForm();
    // this.addSubTax();
    this.taxForm.controls.financialAccountId.setValue(this.getIncomeAccount());
    this.taxForm.controls.countryId.setValue(taxCountry.countryId);
    this.taxForm.controls.addressTypeId.setValue(taxCountry.addressTypeId);
    this.getAllStates({ id: taxCountry.countryId });
  }

  getIncomeAccount() {
    const incomeAccount = this.financialAccounts?.filter(acc => acc.labelName == ObjectNames.setupConstants.incomeAccount)[0];
    return (incomeAccount.children?.filter(child => child.labelName == ObjectNames.setupConstants.incomeAccount)[0]);
  }

  changeCountry(e) {
    const countryObj = this.countries.filter(ele => ele.id == e.value)[0];
    this.getAllStates(countryObj);
  }

  getAllStates(countryObj) {
    this.service.getAllStates(countryObj.id).then((states) => {
      this.states = states;
    });
  }

  showEditRate(rate) {
    this.appMainService.isShowSpinner("loadTax");
    this.taxService.getTaxById(rate.id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (tax) => {
          this.appMainService.isHideSpinner("loadTax");
          this.taxDetails = JSON.parse(JSON.stringify(tax));
          // console.log(this.taxDetails);
          this.setTaxEditData();
        },
        error: (error) => {
          this.appMainService.isHideSpinner("loadTax");
          this.showErrorMsg();
        }
      });
  }

  async setTaxEditData() {
    this.addEditRateHeader = ObjectNames.setupConstants.EditrateTitle;
    this.displayRateAdd = true;
    this.invalidData = false;
    this.isAddTaxRate = false;
    this.subTaxCodes = [];
    this.statusDisabled = this.taxDetails.isDefault ? true : false;
    const filteredCountry = this.countries.filter(country => country.id == this.taxDetails.countryId)[0];
    this.states = await this.service.getAllStates(filteredCountry.id);
    this.selectedCountryId = this.taxDetails.countryId;
    // this.subTaxCodes = await lastValueFrom(this.taxService.getAllSubTaxCodes(this.selectedCountryId));
    // to add new subtaxcode, need add new option in dropdown
    // this.subTaxCodes.push({id: 0, code: "Add New"});

    // set form value
    this.initTaxForm();
    this.taxForm.patchValue(this.taxDetails);
    // this.taxDetails?.subTax?.forEach((element) => {
    //     const code = this.subTaxCodes.find(st => st.id == element.subTaxCodeId);
    //     const type = this.rateTypes.find(rt => rt.id == element.typeId);
    //     const subTaxForm = this.fb.group({
    //         id: [element.id],
    //         code: [code, Validators.required],
    //         typeId: [type, Validators.required],
    //         taxRate: [element.taxRate,[Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
    //     });
    //     this.subTax.push(subTaxForm);
    // });
    this.taxForm.controls['statusId'].setValue(this.taxDetails.statusId == Status.ACTIVE ? true : false);
    this.setFinancialAccountValue(this.taxDetails);
    this.setProductCategoryValue(this.taxDetails);
  }

  setFinancialAccountValue(tax) {
    //For Parent Financial Account
    const filteredFinancialId = this.financialAccounts?.filter(finance => finance.value?.id == tax.financialAccountId)[0];
    this.taxForm.controls['financialAccountId'].setValue(filteredFinancialId);

    //For Child Financial Account
    this.financialAccounts?.forEach(finance => {
      const childAccount = finance.children?.filter(
        (child) => child.value?.id == tax.financialAccountId
      )[0];
      if (childAccount) {
        this.taxForm.controls['financialAccountId'].setValue(childAccount);
      }
    });

    //For Sub-Child Financial Account
    this.financialAccounts.forEach(finance => {
      finance.children?.forEach(element => {
        const subChildAccount = element.children?.filter(
          (child) => child.value?.id == tax.financialAccountId
        )[0];
        if (subChildAccount) {
          this.taxForm.controls['financialAccountId'].setValue(subChildAccount);
        }
      });
    });
    //For forth level Financial Account
    this.financialAccounts.forEach(finance => {
      finance.children?.forEach(fnc => {
        fnc.children?.forEach(element => {
          const forthLevelChildAccount = element.children?.filter(
            (child) => child.value?.id == tax.financialAccountId
          )[0];
          if (forthLevelChildAccount) {
            this.taxForm.controls['financialAccountId'].setValue(forthLevelChildAccount);
          }
        });
      });
    });
  }

  setProductCategoryValue(tax) {
    let productCategories = [];
    tax?.taxProductCategory?.forEach(pCategory => {
      const parentCategory = this.CategoryLists?.find(p => p.id == pCategory.categoryId);
      if (parentCategory)
        productCategories.push(parentCategory);
    });
    tax?.taxProductCategory?.forEach(pCategory => {
      this.CategoryLists?.forEach(category => {
        const childCategory = category["children"]?.find(p => p.id == pCategory.categoryId);
        if (childCategory)
          productCategories.push(childCategory);
      });
    });
    this.taxForm.controls['taxProductCategory'].setValue(productCategories);
  }

  checkDeleteStatus(tax) {
    this.setupService.checkDeleteStatus(tax.id, 'taxRate').subscribe(check => {
      if (!check.item1) {
        this.deleteRate(tax);
      } else {
        this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: `${check.item2}` });
      }
    })
  }

  deleteRate(rate) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Tax Rate?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.taxService.deleteTaxRate(rate.id)
          .subscribe({
            next: (res) => {
              this.showSuccessMsg('Deleted Successfully...');
              this.loadTaxList();
            },
            error: (error) => {
              this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: error?.error?.Message ?? "Error occurred...",
              });
            },
          });
      },
      reject: () => { }
    });
  }

  onBlurSubTaxCode(e, index: number) {
    /**
     * If new value entered in subtaxcode dropdown, need to save that new value as subtaxcode
     */
    if (e.target.value) {
      // this.addSubTaxCode(e.target.value, index);
    }
  }

  // showAddTaxCode(e, index: number){
  //   if (e?.value?.code?.toLowerCase() == 'add new') {
  //     this.displayAddTaxCode = true;
  //   }
  // }

  // hideAddTaxCode(){
  //   this.displayAddTaxCode = false;
  //   // this.groupForm.reset();
  // }

  /**
   * Add new sub tax code
   */
  // addSubTaxCode(value: string, index: number){
  //     const subTaxCodeObj: ISubTaxCode = {
  //       id: 0,
  //       createdSource: this.app.userIP,
  //       updatedSource: this.app.userIP,
  //       createdBy: this.app.userId,
  //       updatedBy: this.app.userId,
  //       createdDate: new Date(),
  //       updatedDate: new Date(),
  //       code: value,
  //       organizationId: this.app.companyId,
  //       countryId : this.taxForm.controls.countryId.value || 0,
  //       stateId : this.taxForm.controls.stateId.value || 0,
  //     }

  //     this.appMainService.isShowSpinner("addSubTaxCode");
  //     this.taxService.addSubTaxCode(subTaxCodeObj)
  //       .pipe(takeUntil(this.unsubscribe$))
  //       .subscribe({
  //           next: (response) => {
  //               this.appMainService.isHideSpinner("addSubTaxCode");
  //               this.showSuccessMsg('Sub Tax Added successfully...');
  //               this.getFormGroupAt(index)?.controls['code']?.setValue("");
  //               this.getAllSubTaxCodesByCountry();
  //           },
  //           error: (error) => {
  //               this.appMainService.isHideSpinner("addSubTaxCode");
  //               this.showErrorMsg(error?.error?.Message);
  //           }
  //     });
  // }
  // addSubTaxCode(){
  //     const subTaxCodeObj: ISubTaxCode = {
  //       id: 0,
  //       createdSource: this.app.userIP,
  //       updatedSource: this.app.userIP,
  //       createdBy: this.app.userId,
  //       updatedBy: this.app.userId,
  //       createdDate: new Date(),
  //       updatedDate: new Date(),
  //       code: this.taxCodeForm.controls.name.value,
  //       organizationId: this.app.companyId,
  //       countryId : this.taxForm.controls.countryId.value || 0,
  //       stateId : this.taxForm.controls.stateId.value || 0,
  //     }

  //     this.appMainService.isShowSpinner("addSubTaxCode");
  //     this.taxService.addSubTaxCode(subTaxCodeObj)
  //       .pipe(takeUntil(this.unsubscribe$))
  //       .subscribe({
  //           next: (response) => {
  //               this.appMainService.isHideSpinner("addSubTaxCode");
  //               this.showSuccessMsg('Sub Tax Added successfully...');
  //               // this.getFormGroupAt(index)?.controls['code']?.setValue("");
  //               this.getAllSubTaxCodesByCountry();
  //               this.hideAddTaxCode();
  //           },
  //           error: (error) => {
  //               this.appMainService.isHideSpinner("addSubTaxCode");
  //               this.showErrorMsg(error?.error?.Message);
  //           }
  //     });
  // }

  /**
   * Add new tax country
   */
  saveTaxCountry() {
    let country = this.countries?.find(c => c.id == this.taxCountryForm.controls.countryId.value);
    const taxCountryObj: ITaxCountry = {
      id: 0,
      createdSource: this.app.userIP,
      updatedSource: this.app.userIP,
      createdBy: this.app.userId,
      updatedBy: this.app.userId,
      createdDate: new Date(),
      updatedDate: new Date(),
      countryId: this.taxCountryForm.controls.countryId.value,
      countryName: country?.name || "",
      addressTypeId: this.taxCountryForm.controls.addressTypeId.value,
      statusId: Status.ACTIVE,
      organizationId: this.app.companyId,
    }

    this.appMainService.isShowSpinner("addTaxCountry");
    this.taxService.addTaxCountry(taxCountryObj)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (response) => {
          this.appMainService.isHideSpinner("addTaxCountry");
          this.showSuccessMsg("Tax Country addedd successfully !!!");
          this.displayTaxCountryAdd = false;
          this.loadTaxList();
        },
        error: (error) => {
          this.appMainService.isHideSpinner("addTaxCountry");
          this.showErrorMsg(error?.error?.Message);
        }
      });

  }

  saveRate(value) {
    // console.log(value);
    this.invalidData = false;
    value.statusId = Status.ACTIVE;
    value.description = value.name;
    value.financialAccountId = (value.financialAccountId ? value.financialAccountId?.value?.id : 0);
    value.taxEnabled = true;
    // value.typeId = this.getFormGroupAt(0)?.controls['typeId']?.value?.id || 0; // typeId of first row of subtax should be passed as typeId is fixed

    let taxType = this.rateTypes?.find(r => r?.name?.toLowerCase() == "percentage");
    value.typeId = taxType ? taxType.id : 0; // typeId of first row of subtax should be passed as typeId is fixed
    value.stateId = this.taxForm.controls.stateId.value || 0;
    value.taxCountryId = this.selectedTaxCountry?.id || 0;

    // subtax
    // let subtaxes: ISubTax[] = [];
    // for(let subTax of this.taxForm?.value?.subTax) {
    //     const subTaxObj: ISubTax = {
    //       id: 0,
    //       createdSource: this.app.userIP,
    //       updatedSource: this.app.userIP,
    //       createdBy: this.app.userId,
    //       updatedBy: this.app.userId,
    //       createdDate: new Date(),
    //       updatedDate: new Date(),
    //       taxId: 0,
    //       subTaxCodeId: subTax?.code?.id || 0,
    //       code: subTax?.code?.code || "",
    //       typeId: subTax?.typeId?.id || 0,
    //       taxRate: subTax?.taxRate,
    //       statusId: Status.ACTIVE
    //     }
    //     subtaxes.push(subTaxObj);
    // };
    // value.subTax = subtaxes;

    // taxProductCategory
    let taxProductCategories: ITaxProductCategory[] = [];
    for (let pCategory of this.taxForm?.value?.taxProductCategory) {
      const taxProductCategoryObj: ITaxProductCategory = {
        id: 0,
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date(),
        updatedDate: new Date(),
        organizationId: this.app.companyId,
        taxId: 0,
        statusId: Status.ACTIVE,
        categoryId: pCategory?.id || 0,
        isValid: true,
        validFromDate: new Date(),
        validToDate: new Date()
      }
      taxProductCategories.push(taxProductCategoryObj);
    };
    value.taxProductCategory = taxProductCategories;

    const lowerCaseNames = [];
    if (this.isAddTaxRate) {
      for (let s of this.allRates) {
        for (let tax of s.tax) {
          if (tax) {
            lowerCaseNames.push(tax.name.toLowerCase().replace(/ /g, ''))
          }
        }
      }
      if (lowerCaseNames.indexOf(value.name.toLowerCase().replace(/ /g, '')) > -1) {
        this.invalidData = true;
      } else {
        this.taxService.addTax(value).then(() => {
          this.showSuccessMsg('Tax Rate Added successfully...')
          this.loadTaxList();
          this.displayRateAdd = false;
          this.activeIndex = 0;
        }).catch(() => {
          this.displayRateAdd = false;
          this.showErrorMsg('Error occurred while saving data...');
        });
      }
    } else {
      let duplicateRecord;
      for (let s of this.allRates) {
        duplicateRecord = s?.tax?.find(depOb => depOb.name.toLowerCase().replace(/ /g, '') == value.name.toLowerCase().replace(/ /g, '') && depOb.id !== value.id);
      }
      if (duplicateRecord) {
        this.invalidData = true;
      } else {
        this.invalidData = false;
        this.updateTaxRate(value);
      }
    }
  }

  updateTaxRate(e) {
    const taxObj = JSON.parse(JSON.stringify(this.taxDetails));
    taxObj.updatedBy = this.app.userId;
    taxObj.updatedDate = new Date().toISOString();
    taxObj.updatedSource = this.app.userIP;

    taxObj.name = this.taxForm.controls.name.value;
    taxObj.description = this.taxForm.controls.name.value;
    taxObj.vendorId = this.taxForm.controls.vendorId.value || 0;
    taxObj.financialAccountId = this.taxForm.controls.financialAccountId.value?.value?.id || 0;
    // taxObj.typeId = this.getFormGroupAt(0)?.controls['typeId']?.value?.id || 0; // typeId of first row of subtax should be passed as typeId is fixed
    taxObj.addressTypeId = this.taxForm.controls.addressTypeId.value || 0;
    taxObj.countryId = this.taxForm.controls.countryId.value || 0;
    taxObj.stateId = this.taxForm.controls.stateId.value || 0;
    taxObj.zipCode = this.taxForm.controls.zipCode.value;
    taxObj.statusId = this.taxForm.controls.statusId.value ? Status.ACTIVE : Status.INACTIVE;
    taxObj.taxRate = this.taxForm.controls.taxRate.value;
    taxObj.taxEnabled = true;
    taxObj.type = null;
    taxObj.vendor = null;

    /**
     * Subtax
     * while updating, if subtax already saved it should be used or it can be new subtax
     */
    // let subtaxes: ISubTax[] = [];
    // this.subTax?.value?.forEach((sTax) => {
    //   const subTax = this.taxDetails?.subTax?.find(st => st.id == sTax.id);
    //   const subTaxObj: ISubTax = {
    //     id: subTax ? subTax.id : 0, 
    //     createdSource: subTax ? subTax.createdSource : this.app.userIP,
    //     updatedSource: this.app.userIP,
    //     createdBy: subTax ? subTax.createdBy : this.app.userId,
    //     updatedBy: this.app.userId,
    //     createdDate: subTax ? subTax.createdDate : new Date(),
    //     updatedDate: new Date(),
    //     taxId: subTax ? subTax.taxId : 0,

    //     subTaxCodeId: sTax?.code?.id || 0,
    //     code: sTax?.code?.code || "",
    //     typeId: sTax?.typeId?.id || 0,
    //     taxRate: sTax?.taxRate,
    //     statusId: subTax ? subTax.statusId : Status.ACTIVE
    //   }
    //   subtaxes.push(subTaxObj);
    // });
    // taxObj.subTax = subtaxes;

    /**
     * taxProductCategory
     * While updating tax, taxProductCategory should always be new one
     */
    let taxProductCategories: ITaxProductCategory[] = [];
    for (let pCategory of this.taxForm?.value?.taxProductCategory) {
      const taxProductCategoryObj: ITaxProductCategory = {
        id: 0,
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date(),
        updatedDate: new Date(),
        organizationId: this.app.companyId,
        taxId: 0,
        statusId: Status.ACTIVE,
        categoryId: pCategory?.categoryId || 0,
        isValid: true,
        validFromDate: new Date(),
        validToDate: new Date()
      }
      taxProductCategories.push(taxProductCategoryObj);
    };
    taxObj.taxProductCategory = taxProductCategories;
    this.updateTax(taxObj);
  }

  updateTax(taxObj) {
    this.taxService.updateTax(taxObj).then(() => {
      this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Tax Rate Updated successfully...' });
      this.loadTaxList();
      this.displayRateAdd = false;
      this.activeIndex = 0;
    }).catch(() => {
      this.displayRateAdd = false;
      this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
    });
  }

  getAllCountries() {
    this.accountService.getAllCountries().then(countries => {
      this.countries = countries;
      // console.log('countries ==>>', this.countries);
    });
  }

  getAllProductCategories() {
    this.CategoryLists = [];
    this.catService.getInventoryGroupList().subscribe(groups => {
      this.productInventoryGroup = groups.filter(s => s.name == ObjectNames.productConstants.productCategoryName)[0];
      this.catService.getInventoryCategoryList(this.productInventoryGroup.id).subscribe(cats => {
        let arr = [];
        for (let c of cats) {

          let childArr1 = [];
          for (let s of c.childCategory) {

            let childArr2 = [];
            for (let m of s.childCategory) {

              let childArr3 = [];
              for (let n of m.childCategory) {
                let eachChild3 = {
                  id: n.id,
                  label: n.name,
                  children: n.childCategory
                }
                childArr3.push(eachChild3);
              }

              let eachChild2 = {
                id: m.id,
                label: m.name,
                children: childArr3
              }
              childArr2.push(eachChild2);
            }

            let eachChild = {
              id: s.id,
              label: s.name,
              children: childArr2
            }
            childArr1.push(eachChild);
          }
          let eachCat = {
            id: c.id,
            label: c.name,
            children: childArr1
          }
          arr.push(eachCat)
        }
        this.CategoryLists = arr;
      });
    });
  }

  getAllAddressTypes() {
    this.appMainService.isShowSpinner("loadAddressTypes");
    this.taxService.getAddressTypes()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (types) => {
          this.addressTypes = types;
          this.appMainService.isHideSpinner("loadAddressTypes");
        },
        error: (error) => {
          this.appMainService.isHideSpinner("loadAddressTypes");
          this.showErrorMsg();
        }
      });
  }

  getAllSubTaxCodesByCountry(countryId?) {
    this.subTaxCodes = [];
    this.appMainService.isShowSpinner("loadSubTaxCodes");
    let cId = countryId ? countryId : this.taxForm.controls.countryId.value || 0;
    this.taxService.getAllSubTaxCodes(cId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (codes) => {
          this.appMainService.isHideSpinner("loadSubTaxCodes");

          if (codes) {
            this.subTaxCodes = codes;
          }
          // to add new subtaxcode, need add new option in dropdown
          this.subTaxCodes.push({ id: 0, code: "Add New" });
        },
        error: (error) => {
          this.appMainService.isHideSpinner("loadSubTaxCodes");
          this.showErrorMsg();
        }
      });
  }

  showErrorMsg(msg?: string) {
    this.messageService.add({
      severity: Severity.Error,
      summary: this.titlecasePipe.transform(Severity.Error),
      detail: msg ? msg : "Error occurred...",
    });
  }

  showSuccessMsg(msg: string) {
    this.messageService.add({
      severity: Severity.Success,
      summary: this.titlecasePipe.transform(Severity.Success),
      detail: msg
    });
  }

  ngOnDestroy(): void {
    if (this.unsubscribe$) {
      this.unsubscribe$.next();
      this.unsubscribe$.complete();
      this.unsubscribe$.unsubscribe();
    }
    this.setupService.setTax('');
  }

  cancel() {
    this.displayRateAdd = false;
    this.activeIndex = 0;
  }

  // nextStep(step) {
  //     var arr = document.getElementsByClassName("p-steps-item");
  //     for (let i in this.menus) {
  //         if (i < step + 1) {
  //             arr[i].classList.add("activeItem");
  //         }
  //     }
  //     this.activeIndex = this.activeIndex + 1;
  //     if(this.activeIndex == 1){
  //         if(this.taxForm.controls.countryId.value && this.selectedCountryId != this.taxForm.controls.countryId.value){
  //         this.selectedCountryId = this.taxForm.controls.countryId.value;
  //         this.getAllSubTaxCodesByCountry(this.selectedCountryId);
  //         this.subTax?.controls.forEach((element, index) => {
  //           this.getFormGroupAt(index)?.controls['code']?.setValue("");
  //         });
  //       }
  //     }
  // }

  // backStep(step) {
  //     var arr = document.getElementsByClassName("p-steps-item");
  //     for (let i in this.menus) {
  //         if (i >= step) {
  //             arr[i].classList.remove("activeItem");
  //         }
  //     }
  //     this.activeIndex = this.activeIndex - 1;
  // }

  isNumberKey(evt) {
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
    return true;
  }

}
